import { githubFetch } from './client';

export interface GitHubUserGetResponse {
  login: string;
  name?: string | null;
  avatar_url: string;
}

export async function githubUserGet(): Promise<GitHubUserGetResponse> {
  return githubFetch<GitHubUserGetResponse>('/rpc/github_user_get');
}
